<template>
  <div style="margin-top: 50px">
    <mt-header title="工单编辑">
      <router-link slot="left" to="">
        <mt-button @click="formReturn" icon="back">返回</mt-button>
      </router-link>
      <div slot="right">
        <mt-button
          :disabled="data.pst.isSucces"
          class="m-1"
          @click="formSubmit(false)"
        >
          <img
            slot="icon"
            src="@/assets/save.png"
            width="24"
            height="24"
            :disabled="data.node.isSucces == true"
          />
        </mt-button>
        <mt-button
          :disabled="data.pst.isSucces"
          class="m-1"
          @click="formSubmit(true)"
        >
          <img
            slot="icon"
            src="@/assets/submit.png"
            width="24"
            height="24"
            :disabled="data.node.isSucces == true"
          />
        </mt-button>
      </div>
    </mt-header>
    <scroll-body
      class="m-2"
      :minheight="200"
      :outheight="160"
      :isScroll="true"
      @resize="resize"
    >
      <template slot="content">
        <div>
          <mt-radio
            title="工单类型"
            v-model="data.pst.pstType"
            :options="[
              { label: '网络留留言', value: '0', disabled: data.pst.isSucces },
              { label: '负面舆情', value: '1', disabled: data.pst.isSucces },
            ]"
            @blur.native.capture="checkPstType"
            :state="filedStatus.pstTypeStatus"
          />
          <mt-field
            :disabled="data.pst.isSucces"
            label="标题"
            v-model="data.pst.title"
            placeholder="请输入标题"
            @blur.native.capture="checkInputTitle"
            :state="filedStatus.titleStatus"
          />
          <mt-field
            :disabled="data.pst.isSucces"
            label="地址"
            v-model="data.pst.pstUrl"
            placeholder="请输入网址"
            @blur.native.capture="checkInpuPstUrl"
            :state="filedStatus.pstUrlStatus"
          />
          <mt-field
            :disabled="data.pst.isSucces"
            label="发贴人"
            v-model="data.pst.name"
            placeholder="请输入网友名称"
            @blur.native.capture="checkPstName"
            :state="filedStatus.pstNameStatus"
          />
          <mt-field
            :disabled="data.pst.isSucces"
            label="时间"
            v-model="data.pst.postingTime"
            placeholder="请输入发贴时间"
            @blur.native.capture="checkPostTime"
            :state="filedStatus.postingTimeStatus"
          />
          <mt-field
            :disabled="data.pst.isSucces"
            label="来源"
            v-model="data.pst.pstSource"
            placeholder="请输入来源"
            @blur.native.capture="checkPstSource"
            :state="filedStatus.pstSourceStatus"
          />
          <mt-field label="内容" disabled />
          <mt-field
            :disabled="data.pst.isSucces"
            type="textarea"
            rows="5"
            v-model="data.pst.pstContent"
            placeholder="请输入帖子内容"
            @blur.native.capture="checkPstContent"
            :state="filedStatus.pstContentStatus"
          />
          <el-card class="box-card" v-if="!data.pst.isSucces">
            <!-- 文件上传组件 -->
            <upload
              :nodeId="data.node.id"
              :uploadTypes="uploadTypes"
              @uploadchange="uploadchange"
              :disabled="data.node.isSucces"
            />
          </el-card>
        </div>
      </template>
    </scroll-body>
  </div>
</template>
  
<script>
// 导入组件
import upload from "../../../components/Contents.vue";
import ScrollBody from "@/components/ScrollBody.vue";
export default {
  components: {
    ScrollBody,
    upload,
  },
  created() {
    this.pstApi.setWindowTitle("编辑工单信息");
    this.data.pst.id = this.$route.params.id;
    this.data.user = this.pstApi.getUserData();
    this.getPst(); //读取舆情信息
  },
  data() {
    return {
      filedStatus: {
        pstTypeStatus: "",
        titleStatus: "",
        pstUrlStatus: "",
        pstNameStatus: "",
        postingTimeStatus: "",
        pstSourceStatus: "",
        pstContentStatus: "",
      },
      bodyStyle: {
        overflowY: "auto",
        overflowX: "hidden",
        listStyle: "none",
        height: 420 + "px",
      },
      tabPosition: "right",
      uploadTypes: [
        { title: "图片", value: "0" },
        // { title: "视频", value: "1" },
      ],
      uploadList: [],
      //数据项
      data: {
        statusName: "",
        pstTypeName: "",
        pst: {
          id: "",
          pstType: "1",
          isSucces:true,
          title: "",
          pstUrl: "",
          name: "",
          postingTime: "",
          pstSource: "",
          pstContent: "",
        },
        user: "",
        nodes: [],
        node: {
          id: "",
          pstId: "5",
          status: -2,
          pstType: "1",
          transferUnitId: "",
          transferUnitName: "",
          isSucces: false,
          unitId: "",
          unitName: "",
          userId: "",
          userName: "",
          nodeMessage: "",
          nodeContent: "",
          lastTime: "2023-12-17 06:12:59",
        },
      },
    };
  },
  methods: {
    resize(height) {
      this.bodyStyle.height = height - 10 + "px";
    },
    //读取舆情信息
    getPst() {
      this.pstApi
        .getHandlePstInfo(this.data.pst.id)
        .then((res) => {
          var data = res.data;
          // console.log(data)
          data.pstType = data.pstType + "";
          this.data.pst = data;

          this.data.nodes = data.nodeInfos;
          this.data.statusName = data.isSucces == false ? "已保存" : "已提交";
          //this.pstApi.getStatusTitle(data.status);
          this.data.pstTypeName = this.pstApi.getPstTypeName(data.pstType);
          var len = data.nodeInfos.length;
          if (len != 1) {
            //this.$toast("节点数不正确");
            return;
          }
          this.data.node = data.nodeInfos[0];
          //console.log(this.data.node);
        })
        .catch((err) => {
          this.$toast("读取失败");
        });
    },
    formReturn() {
      this.$router.back();
      //this.$router.push({ name: "Negatives" });
    },
    uploadchange(uploadList) {
      //console.log("uploadList:",uploadList)
      this.uploadList = uploadList;
    },
    async formSubmit(isSucces) {
      if (this.checkPstType() == "error") {
        this.$toast("工单类型错误");
        return;
      }
      if (this.checkInputTitle() == "error") {
        this.$toast("工单标题不能为空");
        return;
      }
      if (this.checkInpuPstUrl() == "error") {
        this.$toast("来源地址错误");
        return;
      }
      if (this.checkPstName() == "error") {
        this.$toast("发贴人不能为空");
        return;
      }
      if (this.checkPostTime() == "error") {
        this.$toast("发贴时间不能为空");
        return;
      }
      if (this.checkPstSource() == "error") {
        this.$toast("来源不能为空");
        return;
      }
      if (this.checkPstContent() == "error") {
        this.$toast("贴子内容不能为空");
        return;
      }
      let pst = this.data.pst;
      let message = this.data.node.nodeMessage;
      if (this.data.node.isSucces) {
        this.$toast("节点已提交，禁止修改");
        return;
      }

      //保存舆情信息
      var res = await this.pstApi.updateNegative(
        pst.id,
        pst.title,
        pst.pstUrl,
        pst.name,
        pst.postingTime,
        pst.pstSource,
        pst.pstContent,
        //category
        parseInt(pst.pstType)
      );

      //保存节点信息
      if (res && res.status == 200) {
        //提交工单
        if (isSucces) {
          if (message == "") {
            message = "请上级部门审查";
          }
          var ret = await this.pstApi.updateManagerNodeMessage(
            pst.id,
            message,
            isSucces
          );
          if (ret && ret.status == 200) {
            this.$toast(ret.data.message);
            this.$toast("工单提交成功");
            this.formReturn();
            return;
          } else {
            this.$toast("工单提交失败");
          }
        } else {
          this.$toast("工单保存成功");
        }
      } else {
        this.$toast("工单保存失败");
      }
    },
    docViewClose() {
      this.data.docViews.docurls = [];
      this.data.docViews.fileExt = "";
    },
    //
    checkPstType() {
      var pstType = this.data.pst.pstType;
      if (pstType == 0 || pstType == 1) {
        this.filedStatus.pstTypeStatus = "success";
      } else {
        this.filedStatus.pstTypeStatus = "error";
      }
    },
    checkInputTitle() {
      var title = this.data.pst.title;
      if (title) {
        this.filedStatus.titleStatus = "success";
      } else {
        this.filedStatus.titleStatus = "error";
      }
    },
    checkInpuPstUrl() {
      var url = this.data.pst.pstUrl;
      // console.log(url)
      if (this.Common.isURL(url)) {
        this.filedStatus.pstUrlStatus = "success";
      } else {
        this.filedStatus.pstUrlStatus = "error";
      }
    },
    checkPstName() {
      var str = this.data.pst.name;
      if (this.Common.isNull(str)) {
        this.filedStatus.pstNameStatus = "error";
      } else {
        this.filedStatus.pstNameStatus = "success";
      }
    },
    checkPostTime() {
      var dt = this.data.pst.postingTime;
      // console.log(url)
      if (this.Common.isDate(dt)) {
        this.filedStatus.postingTimeStatus = "success";
      } else {
        this.filedStatus.postingTimeStatus = "error";
      }
    },
    checkPstSource() {
      var str = this.data.pst.pstSource;
      if (this.Common.isNull(str)) {
        this.filedStatus.pstSourceStatus = "error";
      } else {
        this.filedStatus.pstSourceStatus = "success";
      }
    },
    checkPstContent() {
      var str = this.data.pst.pstContent;
      if (this.Common.isNull(str)) {
        this.filedStatus.pstContentStatus = "error";
      } else {
        this.filedStatus.pstContentStatus = "success";
      }
    },
  },
};
</script>
  
<style lang="less" scoped>
/deep/.mint-cell {
  min-height: 32px;
}
/deep/ .mint-cell-wrapper {
  font-size: 14px;
}
/deep/ .mint-field .mint-cell-title {
  width: 60px;
}
/deep/input:disabled {
  background-color: #fff;
}
/deep/textarea:disabled {
  background-color: #fff;
}
/deep/textarea.mint-field-core {
  font-size: 14px;
}
</style>